module.exports = __webpack_public_path__ + "img/logo.285a4566.png";